import { render, staticRenderFns } from "./ObstacleComponent.vue?vue&type=template&id=0d065f95&scoped=true"
import script from "./ObstacleComponent.vue?vue&type=script&lang=ts"
export * from "./ObstacleComponent.vue?vue&type=script&lang=ts"
import style0 from "./ObstacleComponent.vue?vue&type=style&index=0&id=0d065f95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d065f95",
  null
  
)

export default component.exports